<div class="page">
  <h1 class="page__heading">Medicaid Parental Consent Form</h1>
  <h2 class="page__subheading" *ngIf="showSummary">
    Summary of Generated Forms
  </h2>
  <br />

  <kendo-card class="container section">
    <div>
      <kendo-grid
        [data]="gridView"
        *ngIf="!showSummary"
        kendoGridSelectBy="studentSk"
        [navigable]="false"
        [loading]="loading"
        (selectionChange)="onSelectionChange($event)"
        [(selectedKeys)]="globalMySelection"
        [pageSize]="state.take"
        [skip]="state.skip"
        [sortable]="true"
        [groupable]="false"
        [columnMenu]="menuSettings"
        filterable="menu"
        [reorderable]="false"
        [resizable]="true"
        [selectable]="{ mode: 'multiple', drag: true }"
        [pageable]="{
          buttonCount: buttonCount,
          info: info,
          type: types,
          pageSizes: pageSizes,
          previousNext: previousNext,
          position: position
        }"
        (pageChange)="pageChange($event)"
      >
        <ng-template kendoGridToolbarTemplate>
          <div class="toolbar-container">
            <div>
              <form [formGroup]="globalForm">
                <kendo-label
                  class="hidden-label"
                  text="Search Student Name or ID"
                  [for]="studentSearch"
                ></kendo-label>
                <kendo-textbox
                  [style.width.px]="298"
                  placeholder="Search Student Name or ID"
                  (valueChange)="onGlobalFilter($event)"
                  formControlName="globalSearch"
                  #studentSearch
                  appNoSpecialChars
                >
                </kendo-textbox>
                <kendo-svg-icon
                  [icon]="searchIcon"
                  class="icon-style"
                  size="medium"
                  themeColor="primary"
                ></kendo-svg-icon>
              </form>
            </div>
            <div class="margin-style assign-button-container">
              <span class="k-mr-4 color-secondary text-bold"
                >{{
                  globalMySelection?.length > 0 ? globalMySelection?.length : 0
                }}
                Selected</span
              >

              <button
                kendoButton
                themeColor="primary"
                [disabled]="globalMySelection?.length === 0"
                (click)="saveConsentForm()"
                kendoGridToolbarFocusable
              >
                <fa-icon [icon]="['fas', 'file-lines']" size="1x"></fa-icon>
                Generate Consent Form
              </button>
            </div>
          </div>
        </ng-template>

        <kendo-grid-checkbox-column
          [width]="50"
          [showSelectAll]="true"
        ></kendo-grid-checkbox-column>

        <kendo-grid-column field="studentFullName" title="Student" [width]="200"  filter="text"
        >
          <ng-template kendoGridCellTemplate let-data>
            <div class="col subsection !k-pt-0">
              <h5 class="primary-color !k-mt-0 k-cursor-pointer" routerLink="/student/{{data?.studentNycId}}">
                {{ data?.studentFName }} {{ data?.studentLName }}
              </h5>
              <p class="secondary-color k-mt-0">
                {{ data?.studentNycId }}
              </p>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="parentFName"
          title="Parent/Guardian"
          [width]="220"  [sortable]="true"
        >
          <ng-template kendoGridCellTemplate let-data>
            <div class="col subsection !k-pt-0">
              <h5 class="!k-mt-0">
                {{ data?.parentFName }} {{ data?.parentLName }}
              </h5>
              <p class="color-secondary">
                {{ formatPhoneNumber(data?.phoneNumber)
                }}<span
                  *ngIf="data?.email && data?.phoneNumber"
                >
                  |
                </span>
                {{ data?.email }}
              </p>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          field="writtenLanguage"
          title="Written Language"
          [width]="220"
        >
        <ng-template kendoGridCellTemplate let-data>
         {{data?.writtenLanguage}} 
        </ng-template></kendo-grid-column>
        <kendo-grid-column
          field="consentOutcome"
          title="Most Recent Consent Response"
          [width]="220"
        >
          <ng-template kendoGridCellTemplate let-data>
            <div>
            <span *ngIf="data?.consentOutcome === true"
              class="consent-yes">
              <fa-icon [icon]="faCheck"
                class="k-text-success"></fa-icon>
              Yes, {{data?.mostRecentConsentDate}}
            </span>
            @if(data?.consentOutcome === true){
             <p class="secondary-color k-mt-0 text-center"> CIN: {{data?.cin}} </p>}
              <span class="consent-no"  *ngIf="data?.consentOutcome === false;">
                <fa-icon
                  [icon]="['fas', 'times']"
                  class="k-text-error"
                ></fa-icon>
                No, {{data?.mostRecentConsentDate}}
              </span>
              </div>
            <!-- <span *ngIf="data?.consentOutcomeDate">
              &nbsp;({{ data?.consentOutcomeDate | date : "MM/dd/yyyy" }})
            </span> -->
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="formLastSent"
          title="Form Last Sent"
          filter="date"
          [width]="220"
        >
          <ng-template kendoGridCellTemplate let-data>
            {{
              data.formLastSent
                ? (data.formLastSent | date : "MM/dd/yyyy")
                : "-"
            }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
        title="Action"
        headerClass="action-column"
        [width]="220"
        >
        <ng-template kendoGridCellTemplate let-data>
              @if(data?.consentOutcome !== null){
              <button kendoButton themeColor="primary" fillMode="outline" (click)="viewForm(data?.documentId)">View Form</button>
            }
            </ng-template>
          </kendo-grid-column>
      </kendo-grid>
      <div *ngIf="showSummary" class="summary-section">
        <h2 class="page__subheading">Summary</h2>
        <p>
          Please see below for a summary of the generated medicaid parental
          consent form(s). To print a form, select the checkbox on the desired
          row and click 'Print'.
        </p>
        <kendo-grid
          [kendoGridBinding]="summaryGrid"
          [hidden]="!showSummary"
          kendoGridSelectBy="studentSk"
          [navigable]="false"
          [(selectedKeys)]="summarySelection"
          [pageSize]="10"
          [sortable]="true"
          [groupable]="false"
          [reorderable]="false"
          [resizable]="false"
          [selectable]="{ mode: 'multiple', drag: true }"
          [pageable]="{
            buttonCount: buttonCount,
            info: info,
            type: types,
            pageSizes: pageSizes,
            previousNext: previousNext,
            position: position
          }"
        >
          <kendo-grid-checkbox-column
            [width]="50"
            [showSelectAll]="true"
          ></kendo-grid-checkbox-column>

          <kendo-grid-column field="studentFName" title="Student" [width]="200">
            <ng-template kendoGridCellTemplate let-data>
              <div class="col subsection !k-pt-0">
                <h5 class="primary-color !k-mt-0">
                  {{ data?.studentFName }} {{ data?.studentLName }}
                </h5>
                <p class="secondary-color k-mt-0">
                  {{ data?.studentNycId }}
                </p>
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="parentFName"
            title="Parent/Guardian"
            [width]="220"
          >
            <ng-template kendoGridCellTemplate let-data>
              <div class="col subsection !k-pt-0">
                <p class="!k-mt-0">
                  {{ data?.parentFName }} {{ data?.parentLName }}
                </p>
                <p class="secondary-color k-mt-0">
                  {{ formatPhoneNumber(data?.phoneNumber)
                  }}<span
                    *ngIf="data?.email && data?.phoneNumber"
                  >
                    |
                  </span>
                  {{ data?.email }}
                </p>
              </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="writtenLanguage"
            title="Form Generated Language"
            [width]="220"
          ><ng-template kendoGridCellTemplate let-data>
            {{data?.writtenLanguage}} 
          </ng-template>
        </kendo-grid-column>
        </kendo-grid>
        <div class="k-d-flex k-mt-4">
          <button
            kendoButton
            themeColor="primary"
            fillMode="solid"
            size="medium"
            [disabled]="!summarySelection?.length" 
            (click)="printConsentForm()"
          >
            Print
          </button>
        </div>
      </div>
    </div>
  </kendo-card>
  <div class="k-float-right k-mt-3 k-mb-2" *ngIf="showSummary">
    <button
      kendoButton
      themeColor="primary"
      fillMode="outline"
      size="medium"
      (click)="returnToParent()"
    >
      Return to List of Medicaid Parental Consent Forms
    </button>
  </div>
</div>
